module.exports = "/images/vendor/blueimp-gallery/play-pause.svg?aa3f7415c9c9eed0ee793ae973c7918f";